/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Outside_LabelInputs */

const en_outside_label = /** @type {(inputs: Outside_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Outside`)
};

/**
* | output |
* | --- |
* | "Outside" |
*
* @param {Outside_LabelInputs} inputs
* @param {{ locale?: "en" }} options
* @returns {LocalizedString}
*/
export const outside_label = /** @type {((inputs?: Outside_LabelInputs, options?: { locale?: "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Outside_LabelInputs, { locale?: "en" }, {}>} */ ((inputs = {}, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return en_outside_label(inputs)
});